export default {
  title: "Zakelijke nummers",

  input: {
    title: "Zakelijke nummers aanpassen",
    chamberOfCommerce: {
      label: "KvK",
      unknown: "Geen kvk nummer ingevoerd",
    },
    vat: {
      label: "BTW",
      unknown: "Geen btw nummer ingevoerd",
    },
  },
}
